import { Injectable } from '@angular/core';
import { ChartElement } from './ChartElement';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { Newcomer } from './Newcomer';
import { ServerResponse } from './ServerResponse';
import { NewcomerResponse } from './NewcomerResponse';
import { StatusCode } from './StatusCode';

@Injectable({
  providedIn: 'root'
})
export class ChartsService {

  host: string = 'https://charts.japanradio.de';

  constructor(private http: HttpClient) { }

  getCharts(): Observable<ChartElement[]> {
    return this.http.get<[]>(`${this.host}/charts`);
  }

  isOpen(): Observable<any> {
    return this.http.get<boolean>(`${this.host}/charts/status`);
  }

  sendVote(vote: ChartElement[], userid: string): Observable<StatusCode> {
    vote = vote.filter(item => {
      return item.ticked == true;
    })

    let votedIdsList : number[] = [];
    vote.forEach(e => {
      votedIdsList.push(e.id);
    });

    console.log(vote);
    let voteJson = {
      voter: userid,
      votes: votedIdsList
    }

    return this.http.post<StatusCode>(`${this.host}/charts/vote`, voteJson);
  }

  sendNewcomer(newcomer: Newcomer): Observable<NewcomerResponse> {
    console.log(newcomer);
    let body = {"artist": newcomer.artist, "name": newcomer.name}
    return this.http.post<any>(`${this.host}/charts/newcomer`, body);
  }
}

